import React from "react";

// Define the type for the file prop
interface File {
  file_name: string;
}

// Utility function to get the background color based on file type
const getBackgroundColor = (fileType: string): string => {
  switch (fileType.toLowerCase()) {
    case "pdf":
      return "bg-red-600"; // Replace with your preferred red shade
    case "xlsx":
      return "bg-green-700"; // Replace with your preferred Excel green shade
    default:
      return "bg-violet-700"; // Default background color
  }
};

// Define the component's props type
interface FileIconProps {
  file: File;
}

const FileIcon: React.FC<FileIconProps> = ({ file }) => {
  const fileType = file.file_name.split(".").pop()?.toLowerCase() || ""; // Safely handle undefined values

  // Build the complete className string
  const containerClass = `h-8 w-8 shrink-0 overflow-hidden rounded-md flex items-center justify-center text-xs ${getBackgroundColor(
    fileType
  )}`;

  return (
    <div className={containerClass}>
      <span className="text-white text-[10px]">{fileType.toUpperCase()}</span>
    </div>
  );
};

export default FileIcon;
